import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { event: String, params: Object };

  fire() {
    try {
      if (window.gtag) {
        window.gtag("event", this.eventValue, this.paramsValue || {});
      }
    } catch (e) {
      // no-op
    }
  }
}
